import Vue from 'vue'
import VueRouter from 'vue-router'
import payBefore from '@/views/payBefore'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: payBefore
  },
  {
    path: '/paymentResult',
    name: 'payResult',
    component: () => import('@/views/payResult')
  },
  {
    path: '/privacyPolice',
    name: 'privacyPolice',
    component: () => import('@/views/privacyPolice')
  }
]

const router = new VueRouter({
  routes
})

export default router
